import { defineStore } from "pinia";
const debug = console.log;

export const useSceneStore = defineStore("scene", {
  state: () => {
    return {
      sceneList: [],
    };
  },
  getters: {
    getDropdownScene() {
      console.log("getDropdownScene", this.sceneList);
      return this.sceneList.map((el) => {
        return {
          label: el.sceneIds?.length ? el.title : el.sceneId.name,
          dataId: el.sceneIds?.length ? el._id : el.sceneId.sceneId,
          items: el.sceneIds?.length
            ? el.sceneIds.map((scene) => ({
                label: scene.name,
                dataId: scene.sceneId,
              }))
            : [],
        };
      });
    },
    getScene() {
      let sceneData = [];
      this.sceneList.forEach((el) => {
        if (el.sceneIds?.length) {
          el.sceneIds.forEach((sceneId) => {
            sceneData.push({ id: sceneId.sceneId, ...sceneId });
          });
        } else {
          sceneData.push({ id: el.sceneId.sceneId, ...el.sceneId });
        }
      });
      return sceneData;
    },
    getAutoTourScenes() {
      return this.getScene.filter(
        (scene, i) => i != 0 && scene.autoTour && scene.active !== false
      );
    },
  },
  actions: {
    setSceneList(scene) {
      debug(scene);
      if (this.sceneList.length) {
        this.sceneList = [];
      }
      this.sceneList = scene;
    },
    getSceneDataById(id) {
      console.log("getSceneDataById", id);
      return this.getScene.find((scene) => scene.id === id);
    },
  },
});
